import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent {

  @Input() steps: StepperStep[] = [];
  @Input() currentStep: number = 1;
  @Input() showConnectors: boolean = true;
  @Input() showStepSubtitles: boolean = false;
  @Input() allowStepNavigation: boolean = false;
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';

  @Output() stepChange = new EventEmitter<number>();

  onStepClick(step: StepperStep, index: number): void {
    if (!this.allowStepNavigation || step.disabled) {
      return;
    }

    // Only allow navigation to completed steps or the next available step
    if (index <= this.currentStep || step.status === 'completed') {
      this.currentStep = index + 1;
      this.stepChange.emit(this.currentStep);
    }
  }

  isStepAccessible(step: StepperStep, index: number): boolean {
    if (!this.allowStepNavigation) {
      return false;
    }

    // Allow navigation to completed steps or the next available step
    return step.status === 'completed' || index <= this.currentStep;
  }

  completeCurrentStep(): void {
    if (this.currentStep < this.steps.length) {
      // Mark current step as completed
      this.steps[this.currentStep - 1].status = 'completed';

      // Move to next step
      this.currentStep++;

      // Update next step to active
      if (this.currentStep <= this.steps.length) {
        this.steps[this.currentStep - 1].status = 'active';
      }
    }
  }

  backToPreviousStep(): void {
    if (this.currentStep > 1) {
      // Update current step to pending
      this.steps[this.currentStep - 1].status = 'pending';

      // Move to previous step
      this.currentStep--;

      // Update previous step to active
      this.steps[this.currentStep - 1].status = 'active';
    }
  }
}

export interface StepperStep {
  id: number;
  title: string;
  subtitle?: string;
  icon?: string;
  status: 'pending' | 'active' | 'completed' | 'error';
  disabled?: boolean;
}
